import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';
import { GetCircuitsVm } from './get-circuits.vm';

export const getCircuits = async (
    offset: string,
    warehouseId: string | null,
    callback: CallbackObject<GetCircuitsVm>
) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
        params: {
            limit: 50,
            offset: offset,
            ...(warehouseId && { warehouseId }),
        }
    };

    try {
        const res: AxiosResponse = await instance.get('/picking/circuits', config);
        callback.success(plainToClass(GetCircuitsVm, res.data));
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
